import { timer } from 'rxjs';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationService } from 'src/app/services/navigation.service'; 

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css']
})
export class ClientesComponent {

  clientes: any[] = [];
  searchTerm: string = '';
  originalClentes: any[] = [];
  loading: boolean = true;
  mensajeClientes: string = '';

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.verificacionUsuario();
  }

  verificacionUsuario(){
    this.navigationService.disableNavigation();
    const token = String(localStorage.getItem('token1')); 
    timer(1).subscribe(() => {
      this.requestsService.getAllClient(token).subscribe((data: any) => {
        this.clientes = data;
        this.originalClentes = data;
        this.loading = false;
        this.clientes.length === 0 && this.mensajeError(`No se tienen clientes que mostrar.`);
      });
    });
  }

  search() {
    if (this.searchTerm) {
      this.clientes = this.originalClentes.filter(clientes => {
        return (
          clientes.Clt_Razon_Social.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      });
    } else {
      this.clientes = this.originalClentes;
    }
  }

  buscador(){
    this.clientes = this.originalClentes.filter(clientes => {
      return (
        clientes.Clt_Razon_Social.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    });
    this.clientes.length === 0 && this.mensajeError(`Con los criterios ${this.searchTerm}, no encontramos ninguna coincidencia.`);
  }

  mensajeError(mensaje:string){
    this.mensajeClientes = mensaje;
  }

  editar(op: any, cliente: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.sharedService.setDataArray(cliente);
    this.router.navigate(['/clientesD', opE]);
  }

  agregar(op: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.router.navigate(['/clientesD', opE]);
  }

}
